import React from 'react'
import Footers from "./Footer";
import Navbar from "./Navbar";
import { motion } from 'framer-motion';

const Smartstoragesolution = () => {
    return (
        <>
            <motion.div className="page-wraper" style={{ background: '#fff' }} initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <Navbar />
                <motion.div className="page-content" initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}>
                    {/* <!-- CONTENT START --> */}
                    <div className="page-content">
                        {/* <!-- INNER PAGE BANNER --> */}
                        <div
                            className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
                            data-stellar-background-ratio="0.5"
                            style={{
                                backgroundImage: "url(assets/pic/home-office.jpg)",
                            }}
                        >
                            <div className="overlay-main bg-black opacity-07"></div>
                            <div className="container">
                                <div className="wt-bnr-inr-entry">
                                    <div className="banner-title-outer">
                                        <div className="banner-title-name">
                                            <h2 className="text-white">Smart Storage Solution </h2>
                                        </div>
                                    </div>
                                    {/* <!-- BREADCRUMB ROW -->  */}

                                    <div>
                                        <ul className="wt-breadcrumb breadcrumb-style-2">
                                            <li>
                                                <a href="/">Home</a>
                                            </li>

                                            <li>Smart Storage Solution</li>
                                        </ul>
                                    </div>

                                    {/* <!-- BREADCRUMB ROW END --> */}
                                </div>
                            </div>
                        </div>
                        {/* <!-- INNER PAGE BANNER END --> */}

                        {/* text start  */}
                        <div style={{ borderBottom: '2px solid #B19777' }}>
                            <div className="container mt-5 mb-5" >
                                <div className="project-detail-outer">
                                    <div className="project-detail-containt">
                                        <div className=" text-black">
                                            <h3 style={{ color: '#B19777' }}>Smart Storage Solution</h3>
                                            <p style={{ color: '#000' }}>
                                                Smart storage transforms overlooked spaces into practical, stylish, and functional areas. Our bespoke solutions make the most of every corner of your home— from under-stair cupboards and lofts to built-in wardrobes and shelving— crafting spaces that simplify your life without ever compromising on style.
                                            </p>

                                        </div>

                                        <div className=" text-black">
                                            <h3 style={{ color: '#B19777' }}>Why bespoke works best:</h3>
                                            <p style={{ color: '#000', marginBottom: '10px' }}>
                                                •	Perfect for awkward corners, sloped ceilings, lofts, or tricky layouts
                                            </p>
                                            <p style={{ color: '#000', marginBottom: '10px' }}>
                                                •	Transforms previously unused spaces into practical and elegant solutions                 </p>


                                        </div>
                                        <div className=" text-black">
                                            <h3 style={{ color: '#B19777' }}>Features:</h3>
                                            <p style={{ color: '#000', marginBottom: '10px' }}>
                                                •	Smart storage solutions with luxurious finishes
                                            </p>
                                            <p style={{ color: '#000', marginBottom: '10px' }}>
                                                •	Built-in wardrobes, shelving, and cupboards designed to fit your space

                                            </p>
                                            <p style={{ color: '#000', marginBottom: '10px' }}>
                                                •	Custom under-stair and loft solutions tailored to your home
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* text end  */}

                        {/* customer start  */}
                        <div
                            className=" overflow-hide v-title-outer"
                            style={{ textAlign: "center", borderBottom: '2px solid #B19777' }}
                        >
                            <div className="section-content">
                                <div className="custom-block-outer clearfix bg-cover">
                                    {/* <div className="custom-right-part "> */}
                                    <div className="custom-right-part-content ">
                                        {/* <div className="video-section-outer"> */}
                                        <div className="our-ability m-t50">
                                            <div className="row">
                                                <div className="col-md-3 col-sm-3">
                                                    <div className="m-b30 text-black  center">
                                                        <h1 className=" font-weight-800 m-b5 site-text-primary">
                                                            <img
                                                                src="/assets/pic/craft1.png"
                                                                alt=""
                                                            />
                                                        </h1>
                                                        <h4 className="wt-tilte m-b0" style={{ color: "#000" }}>10 years warranty</h4>
                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-sm-3">
                                                    <div className="m-b30 text-black  center">
                                                        <h1 className=" font-weight-800 m-b5 site-text-primary">
                                                            <img
                                                                src="/assets/pic/craft2.png"
                                                                alt=""
                                                            />
                                                        </h1>
                                                        <h4 className="wt-tilte m-b0" style={{ color: "#000" }}>
                                                            The best materials
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-sm-3">
                                                    <div className="m-b30 text-black  center">
                                                        <h1 className=" font-weight-800 m-b5 site-text-primary">
                                                            <img
                                                                src="/assets/pic/craft3.png"
                                                                alt=""
                                                            />
                                                        </h1>
                                                        <h4 className="wt-tilte m-b0" style={{ color: "#000" }}>Fast production</h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-sm-3">
                                                    <div className="m-b30 text-black  center">
                                                        <h1 className=" font-weight-800 m-b5 site-text-primary">
                                                            <img
                                                                src="/assets/pic/craft4.png"
                                                                alt=""
                                                            />
                                                        </h1>
                                                        <h4 className="wt-tilte m-b0" style={{ color: "#000" }}>
                                                            Professional installation
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                        {/* customer end  */}
                        {/* <!-- SECTION CONTENT START --> */}
                         <motion.div className="section-full p-t80 p-b50">
                                   <div className="container-fluid">
                                     <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                       {/* <!-- COLUMNS 1 --> */}
                                       <div className="masonry-item col-xl-3 col-lg-4  col-md-6 col-sm-6 m-b30">
                                         <div className="project-img-effect-1">
                                           <img src="assets/pic/hiding5.png" alt="" />
                                         </div>
                                         <div className="project-img-effect-1 mt-4">
                                           <img src="/assets/pic/xyz23.jpg" alt="" />
                                         </div>
                                       </div>
                                       {/* <!-- COLUMNS 2 --> */}
                                       <div className="masonry-item col-xl-3 col-lg-4  col-md-6 col-sm-6 m-b30">
                                         <div className="project-img-effect-1">
                                           <img src="assets/pic/hiding1.jpg" alt="" />
                                         </div>
                                         <div className="project-img-effect-1 mt-4">
                                           <img src="assets/pic/hiding7.png" alt="" />
                                         </div>
                                       </div>
                                       {/* <!-- COLUMNS 3 --> */}
                                       <div className="masonry-item col-xl-3 col-lg-4  col-md-6 col-sm-6 m-b30">
                                         <div className="project-img-effect-1">
                                           <img src="assets/pic/hiding6.png" alt="" />
                                         </div>
                                         <div className="project-img-effect-1 mt-4">
                                           <img src="assets/pic/cabina.jpg" alt="" />
                                         </div>
                                       </div>
                                       {/* <!-- COLUMNS 4 --> */}
                                       <div className="masonry-item col-xl-3 col-lg-4  col-md-6 col-sm-6 m-b30">
                                         <div className="project-img-effect-1">
                                           <img src="assets/pic/hiding2.png" alt="" />
                                         </div>
                                         <div className="project-img-effect-1 mt-4">
                                           <img src="assets/pic/hiding8.png" alt="" />
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </motion.div>
                        {/* <!-- SECTION CONTENT END  --> */}

                    </div>
                    {/* <!-- CONTENT END --> */}
                </motion.div>
                <Footers />
                {/* <!-- BUTTON TOP START --> */}
                <button className="scroltop">
                    <span className="fa fa-angle-up  relative" id="btn-vibrate"></span>
                </button>
            </motion.div>
        </>
    )
}

export default Smartstoragesolution
